module.exports = new __parcel__URL__("wm-map.a9955713.png").toString();